import {
	validateAngle,
	validateAngleValue,
} from "@/shared/utils/angleValidation";
import { splitAngle } from "@/shared/utils/angle";

export const readAngleParts = (raw: string): [string, string] => {
	if (raw.trim() === "") return ["", ""];
	const invalidParts = raw.match(/^(.*)° (.*)′$/);
	if (invalidParts) return [invalidParts[1], invalidParts[2]];
	const value = Number(raw);
	// Invalid persisted values must not become valid by rounding to whole minutes.
	if (validateAngleValue(value)) return [raw, ""];
	const { Degrees, Minutes } = splitAngle(value);
	return [Degrees, Minutes];
};

export const getAngleError = (
	degrees: string,
	minutes: string,
): string | undefined => {
	return validateAngle(degrees, minutes).message;
};
